import { BcInactiveCustomer } from "src/api-service";

// **************************************************************************
// INACTIVE CUSTOMERS STATE
// **************************************************************************
export interface InactiveCustomersState {
    customers: BcInactiveCustomer[] | undefined;
    loading: boolean;
}

export const initialInactiveCustomersState: InactiveCustomersState = {
    customers: undefined,
    loading: false,
};
